import React from 'react'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Typography from '@material-ui/core/Typography'
import makeStyles from '@material-ui/core/styles/makeStyles'
import InstagramIcon from '@material-ui/icons/Instagram'
import FacebookIcon from '@material-ui/icons/Facebook'
import Box from '@material-ui/core/Box'
import { LocationCard } from 'components/program-marketing/location-card'
import ReadMore from 'components/program-marketing/read-more'

const useStyles = makeStyles(theme => ({
  locationListItemIcon: {
    marginTop: '6px',
    minWidth: '40px',
    color: theme.palette.secondary.main,
  },
  locationListItem: {
    padding: '0 40px 8px 0',
    alignItems: 'flex-start',
  },
  innerContainer: {
    paddingTop: theme.spacing(2),
    height: '100%',
  },
  link: {
    textDecorationLine: 'underline',
    fontWeight: 'bold',
    fontFamily: 'PlusJakarta Text',
  },
}))

const InformationListItem = ({ icon, children, link }) => {
  const classes = useStyles()
  return (
    <ListItem component="a" className={classes.locationListItem} href={link}>
      <ListItemIcon className={classes.locationListItemIcon}>
        {icon}
      </ListItemIcon>
      <ListItemText
        primary={
          <Typography
            variant="body2"
            color="textSecondary"
            className={classes.link}
          >
            {children}
          </Typography>
        }
      />
    </ListItem>
  )
}

export const Information = ({
  links = {},
  description,
  viewProgramInformation,
}) => {
  const classes = useStyles()
  const { facebook, instagram } = links

  return (
    <LocationCard title="Program Information">
      <Box className={classes.innerContainer}>
        {description && (
          <ReadMore
            text={description}
            maxLine={10}
            maxLineMobile={3}
            onClick={viewProgramInformation}
          />
        )}
        <List>
          {facebook && (
            <InformationListItem link={facebook} icon={<FacebookIcon />}>
              Facebook
            </InformationListItem>
          )}
          {instagram && (
            <InformationListItem link={instagram} icon={<InstagramIcon />}>
              Instagram
            </InformationListItem>
          )}
        </List>
      </Box>
    </LocationCard>
  )
}
